module.exports = __webpack_public_path__ + "static/Spanring-Brenner-6ff3b553929210b02e61b1fc81021156.jpg";